<template>
    <div class="col-12 col-xl-3 col-lg-4 col-md-6 mb-4">
        <div
            class="widget-small coloured-icon mb-0"
            :class="type"
        >
            <i
                class="icon"
                :class="icon"
            ></i>
            <div class="info">
                <h4>{{ title }} ({{ value }})</h4>
                <b v-if="withData">
                    {{ data[0].label }} {{ data[0].value }} / 
                    {{ data[1].label }} {{ data[1].value }}
                </b>
            </div>
        </div>
        <div :class="'widget-small-footer bg-' + type">
            <a v-if="withLink" :href="link.url">
                {{ link.label }} 
                <i class="fa fa-arrow-circle-right"></i>
            </a>
            <span v-if="!withLink">{{ link.label }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                withLink: false,
                withData: false,
            }
        },
        props: {
            type: { type: String, default: 'info' },
            icon: { type: String, default: 'fa fa-question' },
            title: { type: String, default: 'title' },
            value: { type: Number | String, default: 'value' },
            link: {
                type: Object,
                default: () => {
                    return {
                        label: 'link.label',
                        url: 'link.url',
                    }
                }
            },
            data: {
                type: Array, 
                default: () => {
                    return [
                        { label: 'data.0.label', value: 'data.0.value' },
                        { label: 'data.1.label', value: 'data.1.value' },
                    ];
                }
            },
        },
        mounted() {
            this.withLink = (this.link.url != undefined && this.link.url != 'link.url');
            this.withData = (this.data[0].label != 'data.0.label');
        }
    }
</script>
